var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLadder = function SvgLadder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.583 5a1.25 1.25 0 1 0-2.5 0v30a1.25 1.25 0 0 0 2.5 0v-3.75h10.834V35a1.25 1.25 0 1 0 2.5 0V5a1.25 1.25 0 0 0-2.5 0v3.75H14.583zm10.834 23.75v-4.167H14.583v4.167zM14.583 15.417V11.25h10.834v4.167zm0 2.5v4.166h10.834v-4.166z",
    clipRule: "evenodd"
  })));
};
export default SvgLadder;